import * as React from "react";
import { getMsalInstance } from "../infrastructure/msal";

interface ErrorComponentProps {
  title: string;
  description?: string;
  error?: {
    message: string;
    stack?: string;
  };
  hideDebugInfo?: boolean;
  homeOnly?: boolean;
}

export const ErrorComponent = (props: ErrorComponentProps) => {
  const [hasAuth, setHasAuth] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      try {
        const msalInstance = await getMsalInstance();
        if (msalInstance?.getActiveAccount()) setHasAuth(true);
      } catch {
        /* ignore */
      }
    })();
  }, []);

  const getOperationId = () => {
    if (props.hideDebugInfo) return null;
    const ctx = window.appInsights?.context;
    return ctx?.operation?.id ?? ctx?.telemetryTrace?.traceID ?? null;
  };

  const operationId = getOperationId();

  const goHome = () => (window.location.href = "/");
  const logout = () => typeof window.logout === "function" && window.logout();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          padding: "2rem",
          backgroundColor: "white",
          borderRadius: "8px",
          textAlign: "left",
          marginTop: "10vh",
        }}
      >
        <h1
          style={{
            color: "#D92D20",
            marginBottom: "1rem",
            fontSize: "4rem",
            lineHeight: "1.2",
          }}
        >
          {props.title}
        </h1>

        <p
          style={{
            color: "#002C4A",
            marginBottom: "1.5rem",
            fontSize: "1.5rem",
          }}
        >
          {props.description ??
            "Please reload the application. If the error persists, contact support and supply the information below."}
        </p>

        {props.hideDebugInfo !== true && (
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: "1rem",
              borderRadius: "4px",
              fontFamily: "monospace",
              fontSize: "1.2rem",
              overflow: "auto",
              maxHeight: "200px",
              maxWidth: "600px",
            }}
          >
            {operationId && (
              <p>
                <strong>Operation ID:</strong> {operationId}
              </p>
            )}
            {props.error?.message && (
              <div style={{ marginTop: "0.5rem" }}>
                <strong>Error:</strong> {props.error.message}
              </div>
            )}
            {props.error?.stack && (
              <div style={{ marginTop: "0.5rem" }}>
                <strong>Stack:</strong>
                <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                  {props.error.stack}
                </pre>
              </div>
            )}
          </div>
        )}

        <div style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
          {props.homeOnly ? (
            <button
              onClick={goHome}
              style={{
                padding: "10px 16px",
                backgroundColor: "#5779ad",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                boxShadow: "0px 1px 2px rgba(10, 13, 18, 0.05)",
                height: "44px",
                fontSize: "1.5rem",
              }}
            >
              Take me home
            </button>
          ) : (
            <>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: "10px 16px",
                  backgroundColor: "#5779ad",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow: "0px 1px 2px rgba(10, 13, 18, 0.05)",
                  height: "44px",
                  fontSize: "1.5rem",
                }}
              >
                Reload Application
              </button>

              {hasAuth && (
                <button
                  onClick={logout}
                  style={{
                    padding: "10px 16px",
                    backgroundColor: "#D92D20",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: "0px 1px 2px rgba(10, 13, 18, 0.05)",
                    height: "44px",
                    fontSize: "1.5rem",
                  }}
                >
                  Return to Login
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
